import { onMounted, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import {
  common_querySiteInfo_get,
  common_lang_get
} from '@/server/modules/3426'

export function useCommon() {
  const {
    terminalId,
    brandId,
    channelId,
    siteId,
    subTerminal
  } = useRoute().query
  const state = reactive({
    searchParams: {
      terminalId: terminalId ? Number(terminalId) : 1,
      brandId: brandId ? Number(brandId) : 1,
      channelId: channelId ? Number(channelId) : 1,
      siteId: siteId ? Number(siteId) : 1,
      subTerminal: subTerminal ? Number(subTerminal) : 1
    },
    brands: [],
    channels: [],
    sites: []
  })

  onMounted(async () => {
    const { data } = await common_querySiteInfo_get()
    state.brands = data['1']
    state.channels = data['2']
    state.sites = data['3']
  })

  return {
    ...toRefs(state)
  }
}

export const useSiteLang = function(params) {
  const state = reactive({
    langList: [],
    defaultLang: ''
  })

  const getSiteLang = async () => {
    const { data } = await common_lang_get(params)

    state.langList = Object.entries(data.languageMap).map(([key, value]) => ({
      label: key,
      value: value
    }))
    state.defaultLang = data.defaultLanguageCode
    console.log(state.langList)
  }

  onMounted(() => getSiteLang())

  return {
    ...toRefs(state)
  }
}

export function usePagination() {
  const state = reactive({
    pageNum: 1,
    pageSize: 10,
    total: 0
  })

  return {
    ...toRefs(state)
  }
}
